// components/Typifications.js
import React, { useEffect, useState } from 'react';
import {
  Nav, NavItem, NavLink, TabContent, TabPane, Container, Row, Col
} from 'reactstrap';
import classnames from 'classnames';
import CalificacionesManager from './CalificacionesManager';
import EmbudoManager from './EmbudoManager';
import NegociosManager from './NegociosManager';
import EstadosManager from './EstadosManager';
import { getCampaignList } from '../../../helpers/backend';
import './styles/Typifications.css';

const Typifications = () => {
  const [campaigns, setCampaigns] = useState([]);
  const [activeTab, setActiveTab] = useState(null);
  const [activeCampaign, setActiveCampaign] = useState(null);

  // 🚀 Cargar campañas desde API
  const fetchCampaigns = async () => {
    try {
      const res = await getCampaignList();
      const data = res.data.results || [];
      setCampaigns(data);

      const defaultId = activeTab || (data[0]?.id ?? null);
      setActiveTab(defaultId);

      const selected = data.find(c => c.id === defaultId);
      setActiveCampaign(selected);
    } catch {
      alert('Error cargando campañas');
    }
  };

  useEffect(() => {
    fetchCampaigns();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // ⚡ Usado por los hijos para actualizar campañas
  const refresh = () => {
    fetchCampaigns();
  };

  // Cambio de pestaña
  const toggle = (tabId) => {
    setActiveTab(tabId);
    const selected = campaigns.find(c => c.id === tabId);
    setActiveCampaign(selected);
  };

  return (
    <Container fluid className="typifications-dashboard page-content">
      <h4 className="mb-4">Gestión de Campañas</h4>

      <Nav tabs className="campaign-tabs mb-4">
        {campaigns.map(camp => (
          <NavItem key={camp.id}>
            <NavLink
              className={classnames({ active: activeTab === camp.id })}
              onClick={() => toggle(camp.id)}
            >
              {camp.name}
            </NavLink>
          </NavItem>
        ))}
      </Nav>

      <TabContent activeTab={activeTab}>
        <TabPane tabId={activeTab}>
          {activeCampaign && (
            <>
              <Row className="dashboard-row">
                <Col md={6}>
                  <div className="dashboard-card fade-in">
                    <CalificacionesManager campaign={activeCampaign} onSaved={refresh} />
                  </div>
                </Col>
                <Col md={6}>
                  <div className="dashboard-card fade-in">
                    <EmbudoManager campaign={activeCampaign} onSaved={refresh} />
                  </div>
                </Col>
              </Row>

              <Row className="dashboard-row">
                <Col md={6}>
                  <div className="dashboard-card fade-in">
                    <NegociosManager campaign={activeCampaign} onSaved={refresh} />
                  </div>
                </Col>
                <Col md={6}>
                  <div className="dashboard-card fade-in">
                    <EstadosManager />
                  </div>
                </Col>
              </Row>
            </>
          )}
        </TabPane>
      </TabContent>
    </Container>
  );
};

export default Typifications;
